export default "__VITE_ASSET__CTrgNgnw__"